import IptPxd from './IptPxd';

export default IptPxd;
